import { Component, OnDestroy, OnInit } from '@angular/core';
import { BrandsDataServiceProvider } from '@services/brands/brands.data.service';
import {
	BrandCreationData,
	BrandDetailsInfo,
	BrandList,
	BrandsActions
} from '@models/brands.model';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import { SNModalService } from '@web-services/modal/snModal.service';
import { BrandCreateModalComponent } from '@web-components/brands/modals/brand-create-modal/brand-create-modal';
import { ImportDataModalComponent } from '@web-components/brands/modals/import-data-modal/import-data-modal';
import { NewSubscriptionServiceDataProvider } from '@services/subscription/subscription.service';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { EmptyError } from 'rxjs/util/EmptyError';
import { NavBreadcrumb, PropsAction } from '@models/models';
import { MessageService } from '@services/helpers/message-service/message.service';
import { Location } from '@angular/common';

@Component({
	selector: 'companies-section',
	template: require('./companies-section.component.html'),
	styles: [require('./companies-section.component.scss')]
})
export class CompaniesSectionComponent implements OnInit, OnDestroy {
	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Companies' }
	];

	brands: Array<BrandDetailsInfo> = [];
	brandsActions: BrandsActions;
	actionName: string;

	private importModalRef: NgbModalRef;
	private unsubscribe: Subject<void> = new Subject();

	constructor(
		private brandsDataService: BrandsDataServiceProvider,
		private snModalService: SNModalService,
		private subscriptionService: NewSubscriptionServiceDataProvider,
		private messageService: MessageService,
		private location: Location
	) {}

	ngOnInit(): void {
		this.getBrandsInfo();
		this.listenToPlanChange();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	addNewCompany() {
		if (this.brandsActions.UPGRADE_PLAN) {
			this.subscriptionService.setChoosePlanOpenModalStatus({
				state: true,
				payload: { url: this.brandsActions.UPGRADE_PLAN.url }
			});
		}

		if (this.brandsActions.ADD_NEW_BRAND) {
			this.snModalService
				.openModal(BrandCreateModalComponent)
				.result.then(
					(
						shouldImportData: PropsAction<BrandCreationData | BrandDetailsInfo>
					) => this.successCreateBrand(shouldImportData)
				)
				.catch(() => EmptyError);
		}
	}

	private successCreateBrand(
		brandData: PropsAction<BrandCreationData | BrandDetailsInfo>
	): void {
		if (brandData.action === 'IMPORT') {
			this.handleDataImportModal(brandData.props);
		}

		if (brandData.action === 'REDIRECT') {
			this.updateAndRedirect(brandData.props.companyId);
		}
	}

	successDeleteBrand(): void {
		this.getBrandsInfo();
		this.brandsDataService.getBrandsData();
		this.messageService.showToaster('s_1', 'companyInformation');
	}

	private handleDataImportModal(brandData: BrandCreationData): void {
		this.importModalRef = this.snModalService.openModal(
			ImportDataModalComponent
		);

		this.importModalRef.componentInstance.newBrandData = brandData;

		this.importModalRef.result
			.then((res: BrandDetailsInfo): void => {
				this.updateAndRedirect(res.companyId);
			})
			.catch();
	}

	private getBrandsInfo(): void {
		this.brandsDataService
			.getBrandsInfo()
			.pipe(takeUntil(this.unsubscribe))
			.subscribe((data: BrandList): void => {
				const { brands, actions } = data;

				if (actions.ADD_NEW_BRAND || actions.UPGRADE_PLAN) {
					this.actionName = (
						actions.ADD_NEW_BRAND || actions.UPGRADE_PLAN
					).actionName;
				}

				this.brandsActions = actions;
				this.brands = brands;
			});
	}

	private listenToPlanChange(): void {
		this.subscriptionService.subscriptionData
			.pipe(
				takeUntil(this.unsubscribe),
				skip(1)
			)
			.subscribe((): void => this.getBrandsInfo());
	}

	private updateAndRedirect(companyId: number): void {
		this.location.go(`/settings/company/${companyId}/edit`);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/settings/companies-section/companies-section.component.ts